import dayjs from "dayjs";
import { getTimezoneDateWithOffset } from "../hooks/useCompanyLocalDate";

interface DateDifference {
  updateAt: string;
  maxCountDay?: number;
  gmtOffset?: number;
}

const getDateDifference = (param: DateDifference) => {
  const { updateAt: updateAtParam, maxCountDay = 8, gmtOffset = 0 } = param;

  if (!updateAtParam) {
    return "-";
  }

  const today = getTimezoneDateWithOffset({
    date: dayjs(),
    gmtOffset,
  });
  const updateAt = getTimezoneDateWithOffset({
    date: dayjs(updateAtParam),
    gmtOffset,
  });

  const diffMinute = today.diff(updateAt, "minute");
  const diffHour = today.diff(updateAt, "hour");
  const diffDay = today.diff(updateAt, "day");

  // 8일 이상
  if (diffDay >= maxCountDay) {
    return updateAt.format("YYYY-MM-DD");
  }

  // 하루 이상
  if (diffDay >= 1) {
    return `${diffDay} days ago`;
  }

  //  1 시간 이상
  if (diffHour >= 1) {
    return diffHour === 1
      ? `${Math.floor(diffHour)} hour ago`
      : `${Math.floor(diffHour)} hours ago`;
  }

  // 1 시간 이하
  if (diffMinute > 1) {
    return `${diffMinute} minutes ago`;
  }

  return "1 minute ago";
};

export default getDateDifference;
